import { render } from "./TablePaginator.vue?vue&type=template&id=780b9e0c"
import script from "./TablePaginator.vue?vue&type=script&lang=js"
export * from "./TablePaginator.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__